<template>
  <InputComponent class="prism-editor" :label="$attrs.label" :disabled="$attrs.disabled">
    <prism-editor
      class="prism-editor__field"
      v-model="comp"
      :highlight="highlighter"
      v-bind="$attrs"
    />
  </InputComponent>
</template>

<script>
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'

import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-json'
import 'prismjs/themes/prism-coy.css'
import { ValueComp } from '../utils'
import { InputComponent } from 'vue-elder-input'

export default {
  props: {
    value: String,
    language: {
      type: String,
      default: 'json',
    },
  },
  computed: {
    comp: ValueComp(),
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages[this.language])
    },
  },
  components: {
    PrismEditor,
    InputComponent,
  },
}
</script>

<style lang="scss">
.prism-editor {
  .elder-input {
    &__field--disabled {
      cursor: not-allowed;
      .prism-editor__field {
        pointer-events: none;
        color: var(--grey);
      }
    }
    &__field {
      word-break: break-all;
      font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
      font-size: 14px;
      line-height: 1.5;
      padding: 5px;
      textarea:focus {
        outline: none;
      }
    }
  }
}
</style>
